import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useIsCustomColorTheme } from "@circle-react/hooks/useIsCustomColorTheme";
import { useMasqueradeEnabledAndActive } from "@circle-react/hooks/useMasqueradeEnabledAndActive";
import { useThemeContext } from "@circle-react/providers/Theme";
import { useMatchRoute } from "@tanstack/react-router";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";
import { useIsMemberAreaAppShellEnabled } from "@/react/hooks/useIsMemberAreaAppShellEnabled";

import { useSidebarBorderStyles } from "../Spaces/SidebarV2/hooks";

export const useCommunitySwitcherStyles = (className?: string) => {
  const isMemberAreaAppShellEnabled = useIsMemberAreaAppShellEnabled();
  const isCustomColorTheme = useIsCustomColorTheme();
  const bodyStyles = useSidebarBorderStyles();

  const themeContext = useThemeContext();
  const isDarkAppearance = Boolean(themeContext.isDarkAppearance);

  const matchRoute = useMatchRoute();
  const isAnalyticsRoute = matchRoute({
    to: "/settings/analytics",
    fuzzy: true,
  });

  const isDefault = !isDarkAppearance && !isCustomColorTheme;
  const isDarkDefault = isDarkAppearance && !isCustomColorTheme;
  const hasMasquerade = useMasqueradeEnabledAndActive();

  const v3Presentation = classNames(
    anchorClassNames("community__switcher"),
    className,
    !isMemberAreaAppShellEnabled && "min-h-screen",
    {
      "!bg-c-switcher border-primary border-r":
        isDefault && !isMemberAreaAppShellEnabled,
      "!bg-c-switcher border-c-sidebar border-r":
        isDarkDefault && !isMemberAreaAppShellEnabled,
    },
  );

  const v3Body = classNames("p-4", {
    "min-h-screen": !isMemberAreaAppShellEnabled,
    "!bg-c-sidebar overflow-hidden border-r":
      isCustomColorTheme && !isMemberAreaAppShellEnabled,
    "!top-24": !isAnalyticsRoute && hasMasquerade,
  });

  return {
    presentationClasses: v3Presentation,
    bodyClasses: v3Body,
    bodyStyles,
  };
};
